import {Component, OnInit} from "@angular/core";
import {Kpi} from "../../../model/kpi";
import {MenuItem} from "primeng/api";
import {ActivatedRoute, Router} from "@angular/router";
import {KpisService} from "../../../services/kpis.service";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-kpis-details',
  templateUrl: './kpis-details.component.html',
  styleUrls: ['./kpis-details.component.scss']
})
export class KpisDetailsComponent implements OnInit {
  public navState: any;

  public kpi: Kpi;

  public items: MenuItem[];
  public activeItem: MenuItem;
  public activeItemIndex: number;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private kpisService: KpisService,
              private translocoService: TranslocoService) {
    const navigation = this.router.getCurrentNavigation();
    this.navState = navigation?.extras.state;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => this.loadKpi(params.uuid));

    this.items = [
      {id: 'overview', label: 'common.overview', icon: 'pi pi-home'},
      {id: 'components', label: 'model.components', icon: 'pi pi-mobile'},
      {id: 'measures', label: 'model.measures', icon: 'pi pi-chart-bar'}
    ];

    this.items.forEach(item => {
      this.translocoService.selectTranslate(item.label).subscribe(value => {
        return item.label = value;
      });
    });

    if (this.navState && this.navState.showView) {
      this.activeItemIndex = this.items.indexOf(this.items.filter(item => item.id === this.navState.showView)[0]);
      this.activeItem = this.items[this.activeItemIndex];
    } else {
      this.activeItemIndex = 0;
      this.activeItem = this.items[this.activeItemIndex];
    }

  }

  loadKpi(kpiUuid: string): void {
    this.kpisService.getKpi(kpiUuid).subscribe(response => {
      this.kpi = response.kpi;
    }, error => {
      if(error.status === 404) {
        this.router.navigate(['/not-found']);
      }
    });
  }

  activateMenu(tab): void {
    this.activeItem = tab.activeItem;
    this.activeItemIndex = this.items.indexOf(this.activeItem);
  }

}
